/**
 * Recusas PERMANENTES das lambdas de upload (start/complete). Chegam como 403 com o código
 * em texto puro no corpo (apesar do `Content-Type: application/json`), igual aos ACC-001..005 —
 * o HttpClient não consegue fazer o parse e entrega a string crua em `err.error`.
 *
 * - ACC-006: tipo de arquivo não aceito. No start é a extensão; no complete é o conteúdo
 *   (magic bytes) — nesse caso o objeto já foi apagado do bucket, então o persist NÃO pode ser
 *   chamado (criaria registro sem arquivo, que vai para a DLQ).
 * - ACC-007: nome de arquivo inválido (start).
 *
 * Reenviar o mesmo arquivo não resolve, por isso não confundir com o 403 de armazenamento cheio.
 */
const UPLOAD_REJECTION_KEYS: Record<string, string> = {
  'ACC-006': 'messages.error.uploadFileNotAllowed',
  'ACC-007': 'messages.error.uploadInvalidFileName',
};

/** Chave i18n (param `fileName`) da recusa permanente, ou null se o erro não for uma delas. */
export function uploadRejectionKey(err: unknown): string | null {
  const body = (err as { error?: unknown } | null)?.error;
  return typeof body === 'string' ? UPLOAD_REJECTION_KEYS[body.trim()] ?? null : null;
}
